import { useEffect, useRef } from 'react';

import Box from '@mui/material/Box';
import { TableContainerProps } from '@mui/material/TableContainer';

import ReportsTable from 'components/ReportsTable';

interface Props extends TableContainerProps {
  children: React.ReactNode;
  onIntersecting?: () => void;
  stickyHeader?: boolean;
  hasNextPage?: boolean;
  isGeneralTable?: boolean;
  isFetchingNextPage?: boolean;
}

function TableCustomContainer({
  children,
  onIntersecting = () => {},
  stickyHeader = false,
  hasNextPage = false,
  isGeneralTable = false,
  isFetchingNextPage = false,
}: Props) {
  const scrollPaginationRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (hasNextPage && !isFetchingNextPage) {
          if (entry.isIntersecting) {
            onIntersecting();
          }
        }
      },
      {
        threshold: 0,
      },
    );

    if (scrollPaginationRef.current) observer.observe(scrollPaginationRef.current);

    return () => {
      observer.disconnect();
    };
  }, [scrollPaginationRef, hasNextPage]);

  return (
    <ReportsTable isGeneralTable={isGeneralTable} stickyHeader={stickyHeader}>
      {children}
      <Box id="tableIntersection" mb={1} ref={scrollPaginationRef} />
    </ReportsTable>
  );
}

export default TableCustomContainer;
